import React, { Component, Fragment } from "react";
import { Button, Image, Container } from "react-bootstrap";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";

import PatientsResponsibility from "../PatientsResponsibility/PatientsResponsibility";
import CustomButton from "../../../components/UI/Button/Button";
import Input from "../../../components/UI/Input/Input";
import Modal from "../../../components/UI/Modal/Modal";
import AddSignature from "./AddSignature/AddSignature";
import AddressAlert from "./AddressAlert/AddressAlert";
import ViewDisputeAuthorization from "./ViewDisputeSuthorization/ViewDisputeAuthorization";
import Spinner from "../../../components/UI/Spinner/Spinner";

import classes from "./DisputeAuthorization.module.css";
import * as actions from "../../../store/actions/index.js";
// import { useTranslation,withTranslation } from 'react-i18next';

import dollar from "../../../assets/images/icon-dollar-small.svg";

interface IParentProps {
  goBackHandler: () => void;
}
interface IStateFromProps {
  newUploadData: {
    claimId: number;
    beneficiarySelected: string;
    dateOfService: string;
    procedureLabel: string;
    providerName: string;
    totalChargeAmount: number;
    isMinor: boolean;
    primaryAccountHolder: boolean;
    patientId: number;
    ampsId: string;
  };
  disputeAuthorizationForm: string;
  phone: string;
  email: string;
  documentTypes: {
    id: string;
    type: string;
    editable: boolean;
    order: number;
  }[];
  balanceBillView: string;
  oneTimeSignatureDetails: {
    // documents: {
    //   name: string;
    //   filename: string;
    //   signatureDate: string;
    // }[];

    documentIsSet: boolean;
    addresses: {
      addressLine1: string;
      addressLine2: string;
      addressLine3: string;
      city: string;
      state: string;
      postalCode: string;
      source: string;
    }[];
  };
  loadingOneTimeSignatureAddresses: boolean;
  errorOneTimeSignatureAddresses: boolean;
  // t:any;
  t: any;
  i18n: any;
}
interface IDispatchFromProps {
  onResetDisputeAuthorizationFile: () => void;
  onSubmitBestContactInfo: (any) => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
  onGetOneTimeSignatureAddresses: (patientId) => void;
  onConstructUpdatedAddress: (name: string, value: string) => void;
  onShouldUploadDocument: (shouldUpload: boolean) => void;
}
type Props = IParentProps & IStateFromProps & IDispatchFromProps;
class DisputeAuthorization extends Component<Props> {
  state = {
    patientsResponsibilityStatement: false,
    disputeAuthorizationFormSigned: false,
    addSignature: false,
    signatureAdded: false,
    phone: "",
    errorPhone: "",
    email: "",
    errorEmail: "",
    formValid: false,
    viewingBills: false,
    addressAlertShow: false,
  };
  patientsResponsibilityhandler = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      this.setState({ formValid: true });

      const { phone, email } = this.state;

      let phoneNum = phone.replace(/[^0-9]/g, "");

      const formData = { phoneNum, email };
      this.props.onConstructUpdatedAddress("phone", phoneNum);
      this.props.onConstructUpdatedAddress("email", email);
      this.props.onConstructUpdatedAddress(
        "patientId",
        this.props.newUploadData.patientId.toString()
      );
      console.log(formData);
      this.setState({ patientsResponsibilityStatement: true });
      this.props.onSubmitBestContactInfo({ phone, email });
    }
  };
  patientsResponsibilityBackhandler = () => {
    this.setState({ patientsResponsibilityStatement: false });
    if (this.props.oneTimeSignatureDetails.documentIsSet === true) {
      this.setState({ addressAlertShow: true });
    } else {
      this.props.onShouldUploadDocument(true);
    }
  };
  addSignatureHandler = () => {
    this.setState({ addSignature: true });
  };
  signatureDoneHandler = (signed: boolean) => {
    this.setState({ addSignature: false });
    this.setState({ disputeAuthorizationFormSigned: signed });
  };
  goBackHandler = () => {
    this.props.onResetDisputeAuthorizationFile();
    this.props.onShouldUploadDocument(false);
    this.props.goBackHandler();
  };
  handleChange = (e) => {
    this.setState({ formValid: false });
    this.setState({
      [e.target.name]: e.target.value,
      errorPhone: "",
      errorEmail: "",
    });
  };
  viewingBillsHandler = () => {
    this.setState({ viewingBills: true });
  };
  closeViewingBillsHandler = () => {
    this.setState({ viewingBills: false });
  };
  validateForm = () => {
    let phone = this.state.phone;
    let email = this.state.email;
    let formIsValid = true;
    const { t } = this.props;

    let phonePattern = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/; // (123) 123-1234;

    if (!phonePattern.test(phone)) {
      formIsValid = false;
      this.setState({
        errorPhone: t("errorMsg.errorPhone"),
      });
    }
    let emailPattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    if (!emailPattern.test(String(email).toLowerCase())) {
      formIsValid = false;
      this.setState({
        errorEmail: t("errorMsg.errorEmail"),
      });
    }
    return formIsValid;
  };
  closeAddressAlert = () => {
    this.setState({ addressAlertShow: false });
    this.props.onShouldUploadDocument(true);
  };
  addressConfirmed = () => {
    this.setState({ patientsResponsibilityStatement: true });
    this.setState({ addressAlertShow: false });
    this.props.onShouldUploadDocument(false);
  };
  componentDidMount() {
    console.log("in componentdidmount of DAF");
    this.props.onGetOneTimeSignatureAddresses(
      this.props.newUploadData.patientId
    );
    // this.props.onGetOneTimeSignatureAddresses("2507761");
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.balanceBillView !== this.props.balanceBillView) {
      if (this.props.balanceBillView === "patientsResponsibilityStatement") {
        this.setState({ patientsResponsibilityStatement: true });
      } else if (
        this.props.balanceBillView === "notPatientsResponsibilityStatement" ||
        this.props.balanceBillView === ""
      ) {
        this.setState({ patientsResponsibilityStatement: false });
      }
    }
    if (
      JSON.stringify(prevProps.oneTimeSignatureDetails) !==
        JSON.stringify(this.props.oneTimeSignatureDetails) &&
      JSON.stringify(this.props.oneTimeSignatureDetails) !== JSON.stringify({})
    ) {
      if (this.props.oneTimeSignatureDetails.documentIsSet === true) {
        this.setState({ addressAlertShow: true });
      } else {
        this.props.onShouldUploadDocument(true);
      }
    }
  }
  render() {
    const { t, i18n } = this.props;
    console.log(
      "this.props.disputeAuthorizationForm",
      this.props.disputeAuthorizationForm
    );
    const nextBtnStyle = {
      minWidth: "150px",
    };
    const modalViewBillStyle = {
      width: "840px",
      left: "calc(50% - 420px)",
      top: "3%",
      position: "absolute",
    };
    const modalViewBillStyleSmall = {
      width: "500px",
      left: "calc(50% - 250px)",
      top: "15%",
      position: "absolute",
    };
    const labelHide = {
      display: "none",
    };
    let spinner: any;
    if (this.props.loadingOneTimeSignatureAddresses) {
      spinner = <Spinner />;
    }

    let addressAlert = this.props.oneTimeSignatureDetails &&
      this.props.oneTimeSignatureDetails.addresses && (
        <Modal
          show={this.state.addressAlertShow}
          childComp={
            <AddressAlert
              addressLine1={
                this.props.oneTimeSignatureDetails.addresses[0].addressLine1
              }
              addressLine2={
                this.props.oneTimeSignatureDetails.addresses[0].addressLine2
              }
              addressLine3={
                this.props.oneTimeSignatureDetails.addresses[0].addressLine3
              }
              city={this.props.oneTimeSignatureDetails.addresses[0].city}
              state={this.props.oneTimeSignatureDetails.addresses[0].state}
              postalCode={
                this.props.oneTimeSignatureDetails.addresses[0].postalCode
              }
              goBackHandler={this.goBackHandler}
              modalClosed={this.closeAddressAlert}
              addressConfirmed={this.addressConfirmed}
            />
          }
          style={modalViewBillStyleSmall}
        />
      );
    let addSignatureView: any;
    if (this.state.addSignature) {
      addSignatureView = (
        <Modal
          show={this.state.addSignature}
          childComp={
            <AddSignature
              t={t}
              i={i18n}
              closeAddSignature={this.signatureDoneHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }
    let previewDisputeAuthorizationForm: any;
    if (this.props.disputeAuthorizationForm) {
      previewDisputeAuthorizationForm = (
        <div className="uploadPreviews" onClick={this.viewingBillsHandler}>
          <div className="uploadPreview">
            <img
              //@ts-ignore
              src={URL.createObjectURL(this.props.disputeAuthorizationForm)}
              alt="disputeAuthorization"
            />
          </div>
        </div>
      );
    }
    let disputeAuthorizationBanner: any;
    if (!this.state.disputeAuthorizationFormSigned) {
      disputeAuthorizationBanner = (
        <div className="uploadList">
          <strong>{t("balanceBills.balanceBillDetermination")}</strong>
          <ul>
            <li>{t("balanceBills.authorization")}</li>
          </ul>
        </div>
      );
    }

    let viewBills: any;
    if (this.state.viewingBills) {
      viewBills = (
        <Modal
          show={this.state.viewingBills}
          childComp={
            <ViewDisputeAuthorization
              closeViewing={this.closeViewingBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let disputeAuthorizationInformation: any;
    if (!this.state.disputeAuthorizationFormSigned) {
      disputeAuthorizationInformation = <p>{t("balanceBills.submission")}</p>;
    }
    let patientResponsibility: any;
    if (this.state.patientsResponsibilityStatement) {
      patientResponsibility = (
        <PatientsResponsibility
          t={t}
          goBackHandler={this.patientsResponsibilityBackhandler}
        />
      );
    } else
      patientResponsibility = (
        <Container fluid>
          {addSignatureView}
          {viewBills}
          {addressAlert}
          {spinner}
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t("balanceBilling.balanceBilling")}</h3>
              <Image
                src={dollar}
                alt="stock-image"
                className={classes.stockimage}
                data-test="stockIMG"
              />
            </div>
          </div>
          {/* <button type="button" className="my-bills">
        <span>My Bills</span>
        <Image src={calendar} alt="My Files" />
      </button> */}
          <div className="mainContainer">
            <div>
              <div className="text-center">
                <h6 className="bill-heading">{t("uploadBill.newUpload")}</h6>
                <div className="step-circles">
                  <ul>
                    <li className="active"></li>
                    <li className="active"></li>
                    <li className="select"></li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div>
                <div className="bb-text">
                  <strong>
                    {this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 2
                      )?.type}
                  </strong>
                  {disputeAuthorizationInformation}
                </div>
              </div>
              {disputeAuthorizationBanner}
              {previewDisputeAuthorizationForm}
              <div className="text-center">
                <Button
                  className="btn-lg-border"
                  onClick={this.addSignatureHandler}
                  disabled={false}
                >
                  <span>{t("addSignature.signature")}</span>
                  <i>+</i>
                </Button>
              </div>
              <div className="contact-information">
                <div className="text-center">
                  <h5>{t("submitBill.contactInformation")}</h5>
                  <p>{t("balanceBills.ensureCommunication")}</p>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <Input
                      label=""
                      supportLabel=""
                      placeholder={t("placeHolder.johnEmail")}
                      elementLabelStyle={labelHide}
                      elementInputStyle={{}}
                      name="email"
                      errorText={this.state.errorEmail}
                      value={this.state.email}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group">
                      <NumberFormat
                        format="(###) ###-####"
                        placeholder={t("placeHolder.phoneNo")}
                        name="phone"
                        value={this.state.phone}
                        className="form-control"
                        onChange={(e) => this.handleChange(e)}
                      />
                      <span className="errorMsg">{this.state.errorPhone}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flexButtons">
                <CustomButton
                  label={t("uploadBill.back")}
                  clicked={this.goBackHandler}
                  style={nextBtnStyle}
                  displayImg={false}
                  image=""
                  disabled={false}
                />
                <CustomButton
                  label={t("uploadBill.next")}
                  clicked={this.patientsResponsibilityhandler}
                  style={nextBtnStyle}
                  displayImg={false}
                  image=""
                  disabled={
                    this.props.disputeAuthorizationForm &&
                    this.state.phone &&
                    this.state.email
                      ? false
                      : true
                  }
                />
              </div>
            </div>
          </div>
        </Container>
      );
    return <Fragment>{patientResponsibility}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  disputeAuthorizationForm: state.disputeAuthorization.disputeAuthorizationForm,
  phone: state.bestContactInfo.phone,
  email: state.bestContactInfo.email,
  documentTypes: state.fetchDocumentTypes.documentTypes,
  balanceBillView: state.setBalanceBillViewState.balanceBillView,
  oneTimeSignatureDetails:
    state.oneTimeSignatureAddresses.oneTimeSignatureDetails,
  newUploadData: state.bbNewUpload.newUploadData,
  loadingOneTimeSignatureAddresses: state.oneTimeSignatureAddresses.loading,
  errorOneTimeSignatureAddresses: state.oneTimeSignatureAddresses.error,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onResetDisputeAuthorizationFile: () =>
    dispatch(actions.resetDisputeAuthorizationFile()),
  onSubmitBestContactInfo: (bestContactInfo) => {
    dispatch(actions.fetchBestContactInfo(bestContactInfo));
  },
  onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(actions.setBalanceBillViewState(balanceBillView)),

  onGetOneTimeSignatureAddresses: (patientId) =>
    dispatch(actions.getOneTimeSignatureAddresses(patientId)),
  onConstructUpdatedAddress: (name, value) =>
    dispatch(actions.constructUpdatedAddress(name, value)),
  onShouldUploadDocument: (shouldUplaod) =>
    dispatch(actions.shouldUploadDocument(shouldUplaod)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisputeAuthorization);
// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DisputeAuthorization));
